// src/components/layout/Footer.tsx
import { Link } from 'react-router-dom';
import { Calculator, ExternalLink } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-blue-800 to-blue-600 mt-16">
      <div className="container mx-auto px-4">
        {/* Top Section with Logo */}
        <div className="py-12 border-b border-blue-500/30">
          <Link 
            to="/" 
            className="flex items-center justify-center space-x-3 hover:opacity-90 transition-opacity"
          >
            <Calculator className="h-8 w-8 md:h-10 md:w-10 text-white" />
            <span className="font-bold text-xl md:text-2xl text-white">PayPal Gebührenrechner</span>
          </Link>
        </div>

        {/* Main Footer Content */}
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 xl:gap-12">
            {/* Brand and Logo Section */}
            <div className="col-span-1">
              <div className="space-y-3 text-blue-100">
                <p>© {currentYear} paycal.org</p>
                <p>Alle Rechte vorbehalten</p>
                <p className="text-sm">Aktuelle PayPal Gebühren<br />Stand: Januar 2025</p>
              </div>
            </div>

            {/* Legal Links Section */}
            <div className="col-span-1">
              <h3 className="font-semibold text-white mb-4 text-lg">Rechtliches</h3>
              <nav className="flex flex-col space-y-2">
                <Link 
                  to="/impressum" 
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  Impressum
                </Link>
                <Link 
                  to="/datenschutz" 
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  Datenschutzerklärung
                </Link>
                <Link 
                  to="/agb" 
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  AGB
                </Link>
              </nav>
            </div>

            {/* PayPal Info Section */}
            <div className="col-span-1">
              <h3 className="font-semibold text-white mb-4 text-lg">PayPal Infos</h3>
              <nav className="flex flex-col space-y-2">
                <Link 
                  to="/paypal-gebuehren" 
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  PayPal Gebühren
                </Link>
                <Link 
                  to="/haendlerkonditionen" 
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  Händlerkonditionen
                </Link>
              </nav>
            </div>

            {/* Official PayPal Links Section */}
            <div className="col-span-1">
              <h3 className="font-semibold text-white mb-4 text-lg">Offizielle PayPal Links</h3>
              <nav className="flex flex-col space-y-2">
                <a 
                  href="https://www.paypal.com/de/digital-wallet/paypal-consumer-fees"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-100 hover:text-white transition-colors flex items-center gap-2 group"
                >
                  PayPal Gebühren Info
                  <ExternalLink className="h-4 w-4 opacity-50 group-hover:opacity-100 transition-all" />
                </a>
                <a 
                  href="https://www.paypalobjects.com/marketing/ua/pdf/DE/de/de-de-consumer-fees-09-Jan-2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-100 hover:text-white transition-colors flex items-center gap-2 group"
                >
                  PayPal Gebühren PDF
                  <ExternalLink className="h-4 w-4 opacity-50 group-hover:opacity-100 transition-all" />
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;